
/**
 * 工具类
 */
let utils = {
  msgPrefix: {
    prod: '[vkshop后台]',
    test: '[vkshop后台-test]',
    dev: '[vkshop后台-dev]',
  },
  receiver: {
    prod: '姚金华;郑炜华;全建誉',
    test: '全建誉',
    dev: '全建誉',
  },
  WxCpErrorReport: {
    prod: true,
    test: false,
    dev: false,
  },
  XDebug: {
    prod: false,
    test: false,
    dev: true,
  },
  /**
   * 环境定义
   */
  ENV: {
    PROD: 'prod',
    TEST: 'test',
    DEV: 'dev',
  },
  /**
   * 根据环境获取不同的配置
   * @param env
   */
  getConfig(env = 'prod') {
    let WxCpErrorReport = this.WxCpErrorReport[env]
    let receiver = this.receiver[env]
    let msgPrefix = this.msgPrefix[env]
    let XDebug = this.XDebug[env]
    if (this.isArray(receiver)) {
      receiver = receiver.join('|')
    }
    if (process.env.NODE_ENV === 'development') {
      XDebug = true
    }
    return {
      // 调试参数
      XDebug,
      // 是否开启企业微信错误通知
      WxCpErrorReport,
      // 通知人员
      receiver,
      // 消息体前缀
      msgPrefix,
    }
  },
	/**
	 * scene解码
	 */
	scene_decode(e) {
		if (e === undefined)
			return {};
		let scene = decodeURIComponent(e),
			params = scene.split(','),
			data = {};
		for (let i in params) {
			var val = params[i].split(':');
			val.length > 0 && val[0] && (data[val[0]] = val[1] || null)
		}
		return data;
	},

	/**
	 * 格式化日期格式 (用于兼容ios Date对象)
	 */
	format_date(time) {
		// 将xxxx-xx-xx的时间格式，转换为 xxxx/xx/xx的格式
		return time.replace(/\-/g, "/");
	},

	/**
	 * 格式化详情内容,去除图片之间的间隙，图片宽度最大100%
	 */
	format_content(str) {
		return str.replace(/\<img/gi, '<img style="display:block; margin:0 auto; max-width:100%;" ');
	},
	/**
	 * 格式化文本域换行空格
	 * @param {Object} pretext
	 */
	preText(pretext) {
		return pretext.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\s/g, '&nbsp;')
	},
	/**
	 * 对象转URL
	 */
	urlEncode(data) {
		var _result = [];
		for (var key in data) {
			var value = data[key];
			if (value.constructor == Array) {
				value.forEach(_value => {
					_result.push(key + "=" + _value);
				});
			} else {
				_result.push(key + '=' + value);
			}
		}
		return _result.join('&');
	},

	/**
	 * 遍历对象
	 */
	objForEach(obj, callback) {
		Object.keys(obj).forEach((key) => {
			callback(obj[key], key);
		});
	},

	/**
	 * 是否在数组内
	 */
	inArray(search, array) {
		for (let i in array) {
			if (array[i] == search) {
				return true;
			}
		}
		return false;
	},
	// 是否为字符串
	isString(str) {
		return typeof str === 'string' || str instanceof String;
	},
	// 是否为数组
	isArray(arg) {
		if (typeof Array.isArray === 'undefined') {
			return Object.prototype.toString.call(arg) === '[object Array]'
		}
		return Array.isArray(arg)
	},

	/**
	 * 发送企业微信消息
	 * @param receiver 消息接收人
	 * @param msg 消息文本
	 * @param groupName 群名称
	 * @param isNewGroup 是否强制建立新群
	 */
  sendWxCpMsg(receiver, msg, groupName = '', isNewGroup = false) {
    if (this.isArray(msg)) {
      msg = msg.join('\n')
    }
    if (this.isArray(receiver)) {
      receiver = receiver.join(';', receiver)
    }
    try {
      console.log("请求发送异常信息....")
      this.postRequest('https://msg.kemanduo.com.cn/msg', {receiver, msg, groupName, isNewGroup}, () => {}, () => {}, true)
    } catch (err) {
      console.log("发送...异常信息")
      console.log(err)
    }
  },

  /**
   * 异常消息处理发送通知
   */
  errHandler(error) {
    console.log('进入接口异常捕获')
    let msg = []
    msg.push(config.msgPrefix + '接口异常捕获')
    msg.push(`错误信息:${error.message}`)
    if (error && error.config) {
      msg.push(`请求方式:${error.config.method}`)
      msg.push(`接口地址:${error.config.url}`)
      console.log(error.config.params)
    }
    if (config.WxCpErrorReport && process.env.NODE_ENV === 'production') {
      this.sendWxCpMsg(config.receiver, msg)
    }
  },

	/**
	 * 判断是否为正整数
	 */
	isPositiveInteger(value) {
		return /(^[0-9]\d*$)/.test(value);
	},
  handleResponse(xhr, success, failure) {
    if (xhr.readyState === XMLHttpRequest.DONE) {
      console.log("--------readyState------", xhr.readyState, xhr.status)
      if (xhr.status === 200) {
        if (success !== null && success !== undefined) {
          let result = xhr.responseText
          try {
            success(result, JSON.parse(result));
          } catch (e) {
            success(result, {});
          }
        }
      } else {
        if (failure !== null && failure !== undefined) {
          console.log("error status", xhr.responseText, xhr.status)
          failure(xhr.responseText, xhr.status)
        }
      }
    }
  },
  postRequest(url, arg, success, failure, async) {
    console.log("==========jsPostJSON>>>>>>>>>>>>>>>>==========", url)
    let self = this
    let xhr = new XMLHttpRequest
    xhr.open("POST", url, async)
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded")
    let requestData = ''
    for(let name in arg) {
      requestData += name + '='+ arg[name] + '&'
    }
    requestData = requestData == '' ? '' : requestData.substring(0,requestData.length - 1)
    xhr.onreadystatechange = function () {
      self.handleResponse(xhr, success, failure)
    }
    xhr.send(requestData)
  },
   getDate(timestamp){
    if(timestamp==0){
      return "";
    }
      const timestampMs = timestamp * 1000; // 转为毫秒级（JS需要毫秒）
      
      // 转换为日期对象
      const date = new Date(timestampMs);
      
      // 格式化输出
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份补零
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      
      const delivery_time = `${year}-${month}-${day}`;
      return delivery_time;
    }
}

export default utils;



// WEBPACK FOOTER //
// ./src/utils/utils.js